const adminSchoolsActionPrefix = '@admin-schools/';

/* List of Redux constants */
export const ADMIN_SCHOOLS_SET_LIST_LOADING = `${adminSchoolsActionPrefix}set-list-loading`;
export const ADMIN_SCHOOLS_SET_LIST = `${adminSchoolsActionPrefix}set-list`;
export const ADMIN_SCHOOLS_RESET_LIST = `${adminSchoolsActionPrefix}reset-list`;

/* List of Sagas constants */
export const ADMIN_SCHOOLS_GET_LIST = `${adminSchoolsActionPrefix}get-list`;


// WEBPACK FOOTER //
// ./src/actions/admin/schools/types.js